export const projectStatusEnum = {
  CREATED: 0,
  COMPLETED: 1,
  ONHOLD: 2,
};
